import _ from 'lodash';
import Component from '../abstracts/Component';
import { easter } from 'date-easter';
import flatpickr from 'flatpickr/dist/flatpickr';

/**
 Date picker component
 */
export default class DatePickerComponent extends Component {

    get SELECTORS() {
        return {
            datepicker: '.js-datepicker',
            returnOrderProceed: '.js-proceed-to-confirm',
            dateOfBirth: '.js-dateofbirth',
            calendarPDPGiftcard: '.calendarPDPGiftcard'
        };
    }

    dateFormatByCountry() {
        // Korea: Y-M-D , US : M-D-Y, EU: D-M-Y
        let currentCountry = document.body.dataset.website;
        let dateFormat = '';

        switch (currentCountry) {
            case 'it':
                dateFormat = 'd/m/Y';
                break;
            case 'us':
                dateFormat = 'm/d/Y';
                break;
            default:
                dateFormat = 'd/m/Y';
        }

        return dateFormat;
    }

    initDatepicker(flatpickr, localization, check) {
        let ctx = this;
        let _dateFormat = ctx.dateFormatByCountry();

        $(check).each(function () {

            let _this = $(this);
            let formGroupElement = document.getElementById("appendCalendar");
            let isStatic = false;
            let mindate = null;
            let maxdate = null;
            let defaultDate = Date.parse($(this).data('defaultDate'));
            let disableweekends = $(this).data('disableweekends') || false;
            let isKr = document.body.dataset.website === 'kr';
            let isAdult = $(this).data('adultValidation');
            let changeDateFormat = $(this).data('changeDateFormat');
            mindate = Date.parse($(this).data('mindate'));
            maxdate = Date.parse($(this).data('maxdate'));

            if (disableweekends) {

                var isGLSOrder = document.getElementById("isGLSOrder");
                var country = $("body").data("website");
                var isCountryIT = country != null && country.toLowerCase() === 'it';
                if ((typeof (isGLSOrder) != 'undefined' && isGLSOrder != null && isGLSOrder.value === 'true') || isCountryIT) {
                    var easterDay = easter(new Date().getFullYear());
                    var currentEasterMonday = (easterDay.day + 1) + '/' + easterDay.month;
                }
                _this.flatpickr({
                    static: isStatic ? isStatic : false,
                    disableMobile: 'true',
                    dateFormat: changeDateFormat ? 'Y/m/d' : 'Y-m-d',
                    altInput: true,
                    altFormat: _dateFormat,
                    altInputClass: 'custom-date js-datepicker',
                    minDate: mindate,
                    maxDate: maxdate,
                    allowInput: true,
                    monthSelectorType: 'static',

                    onChange: function (dateObj, dateStr, instance) {
                        if ($('input[name=hourpick]').is(':checked')) {
                            $(ctx.SELECTORS.returnOrderProceed).removeClass('disabled');
                        }
                    },
                    animate: false,
                    disable: [
                        function (date) {
                            var exclude = ['1/1', '6/1', '25/4', '1/5', '2/6', '15/8', '1/11', '8/12', '25/12', '26/12', currentEasterMonday];
                            var d = date.getDate();
                            var m = date.getMonth();
                            var dayExclude = d + '/' + (m + 1);
                            return (date.getDay() === 6 || date.getDay() === 0 || ~$.inArray(dayExclude, exclude));
                        }
                    ],
                    // locale: localization
                });
                const hourpickSelected = $('#hourpickSelected').val();
                if (hourpickSelected) {
                    $('#hourpick').val(hourpickSelected);
                }
            } else if ($(this).hasClass('js-dateofbirth')) {
                // no default on current date
                _this.flatpickr({
                    static: false,
                    disableMobile: 'true',
                    dateFormat: changeDateFormat ? 'Y/m/d' : 'Y-m-d',
                    altInput: true,
                    altFormat: _dateFormat,
                    altInputClass: 'custom-date js-datepicker',
                    minDate: mindate,
                    maxDate: maxdate,
                    //allowInput: true,
                    //clickOpens: false,
                    // locale: localization,
                });
            } else {
                _this.flatpickr({
                    // static: isStatic ? isStatic : false,
                    static: true,
                    disableMobile: 'true',
                    altInput: true,
                    altFormat: _dateFormat,
                    dateFormat: changeDateFormat ? 'Y/m/d' : 'Y-m-d',
                    altInputClass: 'custom-date js-datepicker',
                    minDate: mindate,
                    maxDate: maxdate,
                    allowInput: true,
                    // locale: localization,
                    monthSelectorType: 'static'
                });
            }
        });
    }

    constructor() {
        super();

        this.inputList = document.querySelectorAll('[data-input]');
        if (this.inputList) {
            this.inputList.forEach(input =>
                input.addEventListener('input', (e) => {
                    if (e.target.value && e.target.value !== null && e.target.value !== undefined) input.classList.add('hasValue')
                    if (!e.target.value || e.target.value === null || e.target.value === undefined) input.classList.remove('hasValue')
                })
            )
        }

    }

    getLocalization(lang) {
        switch (lang) {
            case 'en':
                return 'default';
            default:
                return lang;
        }
    }

    render(ajax=false) {
        this.log('Rendering...');
        let lang = this.getLocalization($('html').attr('lang'));
        this.moduleLoader.loadFlatpickr(module => {
            this.moduleLoader.loadFlatpickrLocale(lang, (localization) => {
                this.initDatepicker(module.default, lang, this.SELECTORS.datepicker);
                this.bindEvents(module.default, lang, this.SELECTORS)
                this.setMaxLengthBirthDatePicker();
            },
                err => console.warn('cant load flatpickr')
            );
        });
    }

    bindEvents(moduled, lang, selectors) {
        const ctx = this;
        let isShift = false;

        this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.changed, ({ event, payload }) => {
            ctx.log('Setup for html edit');
            ctx.initDatepicker(moduled, lang, selectors.datepicker);
            this.render();
        });

        if ($(ctx.SELECTORS.datepicker) != null && $(ctx.SELECTORS.datepicker).length > 1) {
            $(ctx.SELECTORS.datepicker)[1].onkeydown = function (e) {
                return ctx.isNumeric(this, e.key, isShift);
            }

            $(ctx.SELECTORS.datepicker)[1].on('input', function (e) {
                return ctx.isNumeric(this, e.key, isShift);
            })

            $(ctx.SELECTORS.datepicker)[1].onkeyup = function (e) {
                ctx.validateDateFormat(this);
            }
        }

        const customDateInput = $('.custom-date');
        const parent = customDateInput.parent();

        customDateInput.on('focusin', (e) => {
            parent.parent().find('.in3-custom-placeholder').addClass('open');
        })
        customDateInput.on('input focusout', (e) => {
            if (customDateInput.val() === '') {
                parent.parent().find('.in3-custom-placeholder').removeClass('open');
            }
        })
    }

    isNumeric(input, keyCode, isShift) {
        let acceptableKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'ArrowRight', 'ArrowLeft'];
        isShift = false;
        let separator = '/'
        if (keyCode === 'ShiftLeft' || keyCode === 'ShiftRight') {
            isShift = true;
        }
        //Allow only numeric keys
        if (acceptableKeys.includes(keyCode) && isShift === false) {
            if ((input.value.length === 2 || input.value.length === 5) && keyCode !== 'Backspace') {
                input.value += separator;
            }
            return true;
        }
        else {
            return false;
        }
    }

    validateDateFormat(input) {
        let dateString = input.value;
        let _dateFormat = this.dateFormatByCountry();
        let regex = /^\d{2}[-]\d{2}[-]\d{4}$/;

        //Check whether valid date format for manual insert.
        if (regex.test(dateString)) {
            //Parsing user manual insert
            let date = flatpickr.parseDate(dateString, _dateFormat);

            //Change calendar view
            $(this.SELECTORS.datepicker)[0]._flatpickr.setDate(date);
        }
    }

    setMaxLengthBirthDatePicker() {
        $(this.SELECTORS.datepicker).attr('maxlength', '10');
    }
}
